<template>
  <v-sheet rounded class="pa-1">
    {{fileName || link}} <a v-ripple class="d-inline-block pa-2 rounded" :href="link" target="_blank" download icon><v-icon size="18">fas fa-file-download</v-icon></a>
  </v-sheet>
</template>

<script>
export default {
  name: 'Downloader',
  props: {
    fileName: {
      type: String
    },
    link: {
      type: String
    }
  }
}
</script>